import { getNestedProperty } from '@opallabs/lambda'
import { State, StateKeys } from '../../../../types'

type GetIds = (state: State) => string[] | undefined

export const getPendingAssignmentsIds: GetIds = (state) =>
  getNestedProperty<string[]>(
    state,
    StateKeys.entityDataByView,
    StateKeys.personalPanel,
    'approvals.pending',
    StateKeys.assignment
  )

export const getPendingPhaseItemsIds: GetIds = (state) =>
  getNestedProperty<string[]>(
    state,
    StateKeys.entityDataByView,
    StateKeys.personalPanel,
    'approvals.pending',
    StateKeys.phase_item
  )

export const getOverdueAssignmentsIds: GetIds = (state) =>
  getNestedProperty<string[]>(
    state,
    StateKeys.entityDataByView,
    StateKeys.personalPanel,
    'approvals.overdue',
    StateKeys.assignment
  )

export const getOverduePhaseItemsIds: GetIds = (state) =>
  getNestedProperty<string[]>(
    state,
    StateKeys.entityDataByView,
    StateKeys.personalPanel,
    'approvals.overdue',
    StateKeys.phase_item
  )

export const getCompletedAssignmentsIds: GetIds = (state) =>
  getNestedProperty<string[]>(
    state,
    StateKeys.entityDataByView,
    StateKeys.personalPanel,
    'approvals.completed',
    StateKeys.assignment
  )

export const getCompletedPhaseItemsIds: GetIds = (state) =>
  getNestedProperty<string[]>(
    state,
    StateKeys.entityDataByView,
    StateKeys.personalPanel,
    'approvals.completed',
    StateKeys.phase_item
  )
